var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-wrapper"},[_c('div',{staticClass:"gc-text--left gc-text--center@m"},[_vm._t("title"),_vm._t("description")],2),_c('div',{staticClass:"form",class:{'form--horizontal': _vm.horizontal}},[_vm._t("form")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }